module.exports = __webpack_public_path__ + "static/media/office-work.4e57991a.png";